import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../../services/api.service';

@Injectable()
export class SearchbarService {
  constructor(
    private api: ApiService
  ) {}

  getSupplyHubData(searchText): Observable<any> {
    return this.api.get('groups/suggest', {search: searchText});
  }
}



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/navbar/searchbar/searchbar.service.ts